// include jQuery in global and window scope (so you can access it globally)
// in your web browser, when you type $('.div'), it is actually refering to global.$('.div')
var jQuery = require('jquery');
global.$ = global.jQuery = jQuery;
window.$ = window.jQuery = jQuery;

const bootstrap = require('bootstrap');
global.boostrap = bootstrap;
window.bootstrap = bootstrap;

const cropper = require('cropperjs');
global.Cropper = cropper;
window.Cropper = cropper;

import Swal from 'sweetalert2/dist/sweetalert2.min.js'
window.Swal = Swal;

// TODO this would maybe speed things up a bit in the future if we wanted to
// try and figure out how to get it to work
import "@hotwired/turbo-rails"
Turbo.setFormMode("optin");

// Use SweetAlert2 for data-turbo-confirm dialogs so they match the rails-ujs
// confirm_swal styling. Note: Turbo-driven links/forms must use turbo_confirm,
// not confirm_swal - the confirm_swal click interceptor runs after Turbo has
// already submitted, causing double-fires.
Turbo.setConfirmMethod((message) => {
  return window.Swal.fire({
    title: 'Are you sure?',
    text: message || '',
    showCancelButton: true,
    confirmButtonText: 'Yes',
    keydownListenerCapture: true,
    confirmButtonAriaLabel: 'Confirm',
    cancelButtonText: 'Cancel',
    cancelButtonAriaLabel: 'Cancel',
    customClass: {
      title: 'color-fanword-black font-fanword-regular',
      confirmButton: 'btn btn-sm px-4 py-2 text-decoration-none border-0 border-fanword-positive bg-fanword-positive color-fanword-black fanword-border-radius',
      cancelButton:  'btn btn-sm px-4 py-2 text-decoration-none fanword-border bg-fanword-white color-fanword-black fanword-border-radius'
    }
  }).then((result) => result.isConfirmed);
});

import '@fortawesome/fontawesome-free/js/all';
import 'chartkick/chart.js';

/* Stimulus Setup */
import { Application } from '@hotwired/stimulus';
import { definitionsFromContext } from '@hotwired/stimulus-webpack-helpers';

const application = Application.start();
const context = require.context("../controllers", true, /\.js$/);

// Configure Stimulus development experience
application.debug = process.env.NODE_ENV === "development";
window.Stimulus   = application;
Stimulus.load(definitionsFromContext(context));

import LocalTime from 'local-time';
LocalTime.start()

// Importing Quill Styles to be used in WYSIWYG layout
import "quill/dist/quill.core.css";

// Rails unobtruisive javascript
import Rails from '@rails/ujs';
Rails.start();
